const formControlMixin = {
  props: {
    value: {
      type: [String, Object, Array, Number, Boolean, Date],
      default: null,
    },
    name: {
      type: String,
    },
    label: {
      type: String,
    },
    description: {
      type: String,
    },
    validate: {
      type: [String, Object],
    },
    validateMode: {
      type: String,
      default: 'aggressive',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    maxlength: {
      type: [String, Number],
    },
    minlength: {
      type: [String, Number],
    },
    max: {
      type: [String, Number],
    },
    min: {
      type: [String, Number],
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: null,
    },
    mask: {
      default: null,
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    normalLabel: {
      type: Boolean,
      default: false,
    },
    itemValue: {
      type: String,
      default: 'id',
    },
    itemText: {
      type: String,
      default: 'name',
    },
  },
  data() {
    return {
      formControlId: null,
      proxy: null,
      loader: false,
    };
  },
  computed: {
    isRequired() {
      if (typeof this.validate === 'string') {
        return this.validate.indexOf('required') !== -1;
      } else if (typeof this.validate === 'object') {
        return this.validate.required === true;
      } else {
        return false;
      }
    },
    formControlOptions() {
      return {
        name: this.name,
        disabled: this.disabled,
        multiple: this.multiple,
        maxlength: this.maxlength,
        minlength: this.minlength,
        max: this.max,
        min: this.min,
        readonly: this.readonly,
        placeholder: this.placeholder,
        returnObject: this.returnObject,
        autocomplete: 'off',
      };
    },
  },
  methods: {
    onInput() {
      this.$emit('input', this.proxy);
    },
    onChange() {
      this.$emit('change', this.proxy);
    },
  },
  watch: {
    value() {
      this.proxy = this.value;
    },
  },
  created() {
    this.formControlId = this.$uuid();
    this.proxy = this.value;
  },
};

export default formControlMixin;
